import { NavLink, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Button } from "./ui/button";

const items = [
  { to: "/admin/dashboard", label: "Overview", id: "01" },
  { to: "/admin/analytics", label: "Analytics", id: "02" },
  { to: "/admin/lives", label: "Lives", id: "03" },
  { to: "/admin/drops", label: "Drop Overview", id: "04" },
  { to: "/admin/products", label: "Inventory", id: "05" },
  { to: "/admin/bookings", label: "Bookings", id: "06" },
  { to: "/admin/users", label: "Users", id: "07" },
  { to: "/admin/waitlist", label: "Waitlist", id: "08" },
  { to: "/admin/price-engine", label: "Price Engine", id: "09" },
];

export default function AdminShell({ children }) {
  const { admin, logoutAdmin } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen grid lg:grid-cols-[260px_1fr]">
      <aside className="border-r border-[#E5E1D8] bg-[#FFFFFF] p-6 flex flex-col gap-8">
        <Link to="/admin/dashboard" className="block">
          <div className="brand-tag">[ ADMIN ]</div>
          <div className="font-display text-2xl uppercase tracking-tight mt-1">Control Room</div>
        </Link>
        <nav className="flex flex-col gap-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              className={({ isActive }) =>
                `border ${isActive ? "border-[#FF6A00] bg-[#FF6A00] text-[#161616]" : "border-[#E5E1D8] hover:border-[#C4BEB0] text-[#161616]"} px-4 py-3 font-mono-ds text-xs uppercase tracking-widest transition-colors flex items-center justify-between`
              }
              data-testid={`admin-nav-${it.label.toLowerCase()}`}
            >
              <span>{it.label}</span>
              <span className="opacity-50">{it.id}</span>
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto pt-6 border-t border-[#E5E1D8]">
          <div className="font-mono-ds text-[10px] uppercase tracking-[0.3em] text-[#6E6E6E] mb-2">Signed in as</div>
          <div className="font-mono-ds text-xs text-[#161616] truncate mb-3" data-testid="admin-signed-in-email">{admin?.email}</div>
          <Button
            onClick={() => { logoutAdmin(); nav("/admin"); }}
            variant="outline"
            className="w-full rounded-2xl border-[#E5E1D8] hover:border-[#FF6A00] hover:text-[#FF6A00] bg-transparent text-[#161616] font-mono-ds uppercase text-xs"
            data-testid="admin-logout-btn"
          >
            Sign Out
          </Button>
          <Link to="/" className="mt-3 block text-center font-mono-ds text-[10px] uppercase tracking-[0.3em] text-[#6E6E6E] hover:text-[#FF6A00]">
            ↩ Public Site
          </Link>
        </div>
      </aside>

      <main className="p-6 md:p-10 grid-bg min-h-screen">
        {children}
      </main>
    </div>
  );
}
